import React, { useState } from 'react';
import api from '../api/api';
import styled from 'styled-components';
import { FaSpinner } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';
// import { history } from '../index';

const LoginPageWrapper = styled.div`

    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;

    .login-box {
        width:400px;
        display: flex;
        flex-direction:column;
    }
    .login-box > * {
        margin-top:10px;
    }
    .logo-container {
        display:flex;
        justify-content: center;
        padding: 2rem;
    }
    .error {
        font-weight: bold;
    }
    .code-info {
        line-height: 1.5;
    }
    .code-actions {
        display: flex;
        gap: 10px;
        margin-top: 2rem;
    }
    .code-actions .secondary {
        flex: 1;
        background: white;
        color: #00ADD8;
        border: 1px solid #00ADD8;
        box-shadow: none;
    }
    .code-actions .secondary:disabled {
        background: #f3f6fa;
        color: #9aa3b0;
        border-color: #d5dbe3;
    }
    .code-help {
        margin-top: 2rem;
        font-size: 0.85rem;
        font-style: italic;
        color: #6b7480;
    }
`;

const LoginPage = () => {


    const [ username, setUsername ] = useState('');
    const [ password, setPassword ] = useState('');
    const [ code, setCode ] = useState('');
    const [ codeRequired, setCodeRequired ] = useState(false);
    const [ resent, setResent ] = useState(false);
    const [ error, setError ] = useState('');
    const [ loading, setLoading ] = useState(false);
    const location = useLocation();
    const { from } = (location.state as any) || { from: { pathname: "/" } };

    const login = (e?: React.FormEvent, withCode = codeRequired) =>{
        e?.preventDefault();
        setError('')
        setLoading(true)
        api().login(username, password, withCode ? code : undefined).then(result=>{
            window.location.href = from.pathname + (from.search || '');
            // history.push(from.pathname)
        }).catch(err => {
            const msg = err?.response?.data;
            if (msg === 'CODE_REQUIRED') {
                setCodeRequired(true);
            } else {
                setError(codeRequired ? msg || 'Invalid code' : 'Invalid username/password')
            }
            setLoading(false)
        });
    }

    // a login attempt without a code makes the server issue a fresh one
    const resend = () => { setResent(true); setCode(''); login(undefined, false); }
    const backToLogin = () => { setCodeRequired(false); setResent(false); setCode(''); setError(''); }

    return <LoginPageWrapper>
        <form className="login-box" onSubmit={login}>
            <div className="logo-container investi-dark-blue"><img src="/images/logo.svg" alt="logo" className="front-page-logo " /></div>
            { !codeRequired && <>
                <input type="text" placeholder="username" autoComplete="username" onChange={(e: any) => setUsername(e.target.value)} disabled={loading} />
                <input type="password" placeholder="password" autoComplete="current-password" onChange={(e: any) => setPassword(e.target.value)} disabled={loading} />
            </> }
            { codeRequired && <>
                <p className="code-info">You're signing in from a browser we don't recognise. We've emailed a verification code to <strong>{username}</strong> — enter it below.</p>
                <input type="text" inputMode="numeric" autoComplete="one-time-code" placeholder="6-digit code" value={code} autoFocus
                    onChange={(e: any) => setCode(e.target.value)} disabled={loading} />
            </> }
            {error && <p className="error">{error}</p>}
            <button type="submit" disabled={loading}>{codeRequired ? 'Verify' : 'Login'} &nbsp;
            { loading && <FaSpinner className="fa-spin" size={16} color="white" />}
            </button>
            { codeRequired && <div className="code-actions">
                <button type="button" className="secondary button-sm" onClick={backToLogin} disabled={loading}>Back to login</button>
                <button type="button" className="secondary button-sm" onClick={resend} disabled={resent || loading}>{resent ? 'Code resent' : 'Resend code'}</button>
            </div> }
            { codeRequired && <p className="code-help">Code not arriving? Check your junk/spam folder first, then email <a href="mailto:contact@investi.com.au">contact@investi.com.au</a> if you still can't sign in.</p> }
        </form>
        </LoginPageWrapper>

}

export default LoginPage;
